// Axios singleton used by all web-portal pages.
// – Request interceptor:  attaches Authorization: Bearer <token>
// – Response interceptor: on 401, wipes tokens and hard-navigates to /login
//   so the user is never stuck on a "Invalid or missing token" screen.

import axios from 'axios';

const ACCESS_KEY = 'serps_access_token';

export const api = axios.create({
  baseURL: (import.meta as ImportMeta & { env: Record<string, string> }).env['VITE_API_BASE_URL'] || '',
  headers: { 'Content-Type': 'application/json' },
  timeout: 30_000,
});

// ── Request interceptor ────────────────────────────────────────────────────
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(ACCESS_KEY);
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// ── Response interceptor ───────────────────────────────────────────────────
api.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    if (
      axios.isAxiosError(error) &&
      error.response?.status === 401 &&
      // don't redirect on the login call itself
      !error.config?.url?.includes('/auth/login')
    ) {
      // Wipe all stored credentials
      localStorage.removeItem('serps_access_token');
      localStorage.removeItem('serps_refresh_token');
      localStorage.removeItem('serps_user');
      // Hard navigate — clears React state, forces re-login
      window.location.href = '/';
    }
    return Promise.reject(error);
  },
);

export default api;
